import { useEffect } from 'react';
import useMemoizedArray from '../../modules/react/hooks/useMemoizedArray';

const useMemoizedNavigationPageIds = (navigation) => {
  const [memoizedPageIds, setMemoizedPageIds] = useMemoizedArray();

  const getPageIds = array => array.reduce((ids, navigationItem) => ([
    ...ids,
    navigationItem.page ? navigationItem.page.id : undefined,
    ...(navigationItem.navigationItems ? getPageIds(navigationItem.navigationItems) : []),
  ].filter(Boolean)), []);

  useEffect(() => {
    const pageIds = getPageIds(navigation || []);
    setMemoizedPageIds(pageIds);
  }, [navigation]);

  return memoizedPageIds;
};

export default useMemoizedNavigationPageIds;
